import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { MissingFormatWithOptions } from "./internal/MissingFormat.js";
import { TemporalUtils } from "./internal/TemporalUtils.js";
// required for `fromNow` to work
dayjs.extend(relativeTime);
export var DayjsRelativeTimeFormat = /*#__PURE__*/ function() {
    "use strict";
    function DayjsRelativeTimeFormat() {
        _class_call_check(this, DayjsRelativeTimeFormat);
    }
    var _proto = DayjsRelativeTimeFormat.prototype;
    _proto.format = function format(value) {
        return TemporalUtils.toDayjs(value).fromNow();
    };
    _proto.resolvedOptions = function resolvedOptions() {
        return {
            locale: dayjs.locale()
        };
    };
    return DayjsRelativeTimeFormat;
}();
export var DayjsRelativeTimeMissingFormat = /*#__PURE__*/ function(MissingFormatWithOptions) {
    "use strict";
    _inherits(DayjsRelativeTimeMissingFormat, MissingFormatWithOptions);
    var _super = _create_super(DayjsRelativeTimeMissingFormat);
    function DayjsRelativeTimeMissingFormat(options) {
        _class_call_check(this, DayjsRelativeTimeMissingFormat);
        return _super.call(this, new DayjsRelativeTimeFormat(), options);
    }
    return DayjsRelativeTimeMissingFormat;
}(MissingFormatWithOptions);

//# sourceMappingURL=DayjsRelativeTimeMissingFormat.js.map